// Taken from http://unicode.org/emoji/charts/full-emoji-list.html
export default [
  "😀","😁","😂","🤣","😃","😄","😅","😆","😉","😊","😋","😎","😍","😘","😗","😙","😚",
  "🙂","🤗","🤔","😐","😑","😶","🙄","😏","😣","😥","😮","🤐","😯","😪","😫","😴","😌",
  "😛","😜","😝","🤤","😒","😓","😔","😕","🙃","🤑","😲","🙁","😖","😞","😟","😤","😢",
  "😭","😦","😧","😨","😩","😬","😰","😱","😳","😵","😡","😠","😷","🤒","🤕","🤢","🤧",
  "😇","🤠","🤡","🤥","🤓","😈","👿","👹","👺","💀","👻","👽","👾","🤖","💩","😺","😸",
  "😹","😻","😼","😽","🙀","😿","😾","🙈","🙉","🙊","👶","👦","👧","👨","👩","👴","👵",
  "👮","🕵","💂","👷","🤴","👸","👳","👲","👱","🤵","👰","🤰","👼","🎅","🤶","🙍","🙎",
  "🙅","🙆","💁","🙋","🙇","🤦","🤷","💆","💇","🚶","🏃","💃","🕺","👯","🛀","🛌","🕴",
  "🗣","👤","👥","🤺","🏇","⛷","🏂","🏌","🏄","🚣","🏊","⛹","🏋","🚴","🚵","🏎","🏍",
  "🤸","🤼","🤽","🤾","🤹","👫","👬","👭","💏","💑","👪","🤳","💪","👈","👉","👆","🖕",
  "👇","🤞","🖖","🤘","🤙","🖐","✋","👌","👍","👎","✊","👊","🤛","🤜","🤚","👋","👏",
  "👐","🙌","🙏","🤝","💅","👂","👃","👣","👀","👁","👅","👄","💋","💘","💓","💔","💕",
  "💖","💗","💙","💚","💛","💜","🖤","💝","💞","💟","💌","💤","💢","💣","💥","💦","💨",
  "💫","💬","🗨","🗯","💭","🕳","👓","🕶","👔","👕","👖","👗","👘","👙","👚","👛","👜",
  "👝","🛍","🎒","👞","👟","👠","👡","👢","👑","👒","🎩","🎓","⛑","📿","💄","💍","💎",
  "🐵","🐒","🦍","🐶","🐕","🐩","🐺","🦊","🐱","🐈","🦁","🐯","🐅","🐆","🐴","🐎","🦄",
  "🐮","🐂","🐃","🐄","🐷","🐖","🐗","🐽","🐏","🐑","🐐","🐪","🐫","🐘","🦏","🐭","🐁",
  "🐀","🐹","🐰","🐇","🐿","🐻","🐨","🐼","🐾","🦃","🐔","🐓","🐣","🐤","🐥","🐦","🐧",
  "🕊","🦅","🦆","🦉","🐸","🐊","🐢","🦎","🐍","🐲","🐉","🐳","🐋","🐬","🐟","🐠","🐡",
  "🦈","🐙","🐚","🦀","🦐","🦑","🐌","🦋","🐛","🐜","🐝","🐞","🕷","🕸","🦂","💐","🌸",
  "💮","🏵","🌹","🥀","🌺","🌻","🌼","🌷","🌱","🌲","🌳","🌴","🌵","🌾","🌿","🍀","🍁",
  "🍂","🍃","🍇","🍈","🍉","🍊","🍋","🍌","🍍","🍎","🍏","🍐","🍑","🍒","🍓","🥝","🍅",
  "🍆","🥔","🥕","🌽","🌶","🥒","🍄","🥜","🌰","🍞","🥐","🥖","🥞","🧀","🍖","🍗","🍔",
  "🍟","🍕","🌭","🌮","🌯","🥙","🥚","🍳","🥘","🍲","🍿","🍱","🍘","🍙","🍚","🍛","🍜",
  "🍝","🍠","🍢","🍣","🍤","🍥","🍡","🍦","🍧","🍨","🍩","🍪","🎂","🍰","🍫","🍬","🍭",
  "🍮","🍯","🍼","🥛","🍵","🍶","🍾","🍷","🍸","🍹","🍺","🍻","🥂","🥃","🍽","🍴","🥄",
  "🔪","🏺","🌍","🌎","🌏","🌐","🗺","🗾","🏔","⛰","🌋","🗻","🏕","🏖","🏜","🏝","🏞",
  "🏟","🏛","🏗","🏘","🏙","🏚","🏠","🏡","🏢","🏣","🏤","🏥","🏦","🏨","🏩","🏪","🏫",
  "🏬","🏭","🏯","🏰","💒","🗼","🗽","⛪","🕌","🕍","⛩","🕋","⛲","⛺","🌁","🌃","🌄",
  "🌅","🌆","🌇","🌉","🌌","🎠","🎡","🎢","💈","🎪","🎭","🖼","🎨","🎰","🚂","🚃","🚄",
  "🚅","🚆","🚇","🚈","🚉","🚊","🚝","🚞","🚋","🚌","🚍","🚎","🚐","🚑","🚒","🚓","🚔",
  "🚕","🚖","🚗","🚘","🚙","🚚","🚛","🚜","🚲","🛴","🛵","🚏","🛣","🛤","⛽","🚨","🚥",
  "🚦","🚧","🛑","⛵","🛶","🚤","🛳","⛴","🛥","🚢","🛩","🛫","🛬","💺","🚁","🚟","🚠",
  "🚡","🛰","🚀","🛎","🚪","🛏","🛋","🚽","🚿","🛁","⌛","⏳","⌚","⏰","⏱","⏲","🕰",
  "🕛","🕧","🕐","🕜","🕑","🕝","🕒","🕞","🕓","🕟","🕔","🕠","🕕","🕡","🕖","🕢","🕗",
  "🕣","🕘","🕤","🕙","🕥","🕚","🕦","🌑","🌒","🌓","🌔","🌕","🌖","🌗","🌘","🌙","🌚",
  "🌛","🌜","🌡","🌝","🌞","⭐","🌟","🌠","⛅","⛈","🌤","🌥","🌦","🌧","🌨","🌩","🌪",
  "🌫","🌬","🌀","🌈","🌂","⛱","⛄","🔥","💧","🌊","🎃","🎄","🎆","🎇","✨","🎈","🎉",
  "🎊","🎋","🎍","🎎","🎏","🎐","🎑","🎀","🎁","🎗","🎟","🎫","🎖","🏆","🏅","🥇","🥈",
  "🥉","⚽","⚾","🏀","🏐","🏈","🏉","🎾","🎱","🎳","🏏","🏑","🏒","🏓","🏸","🥊","🥋",
  "🥅","🎯","⛳","⛸","🎣","🎽","🎿","🎮","🕹","🎲","🃏","🀄","🎴","🔇","🔈","🔉","🔊",
  "📢","📣","📯","🔔","🔕","🎼","🎵","🎶","🎙","🎚","🎛","🎤","🎧","📻","🎷","🎸","🎹",
  "🎺","🎻","🥁","📱","📲","📞","📟","📠","🔋","🔌","💻","🖥","🖨","🖱","🖲","💽","💾",
  "💿","📀","🎥","🎞","📽","🎬","📺","📷","📸","📹","📼","🔍","🔎","🔬","🔭","📡","🕯",
  "💡","🔦","🏮","📔","📕","📖","📗","📘","📙","📚","📓","📒","📃","📜","📄","📰","🗞",
  "📑","🔖","🏷","💰","💴","💵","💶","💷","💸","💳","💹","💱","💲","📧","📨","📩","📤",
  "📥","📦","📫","📪","📬","📭","📮","🗳","🖋","🖊","🖌","🖍","📝","💼","📁","📂","🗂",
  "📅","📆","🗒","🗓","📇","📈","📉","📊","📋","📌","📍","📎","🖇","📏","📐","🗃","🗄",
  "🗑","🔒","🔓","🔏","🔐","🔑","🗝","🔨","⛏","🛠","🗡","🔫","🏹","🛡","🔧","🔩","🗜",
  "🔗","⛓","💉","💊","🚬","🗿","🛢","🔮","🛒","🏧","🚮","🚰","🚹","🚺","🚻","🚼","🚾",
  "🛂","🛃","🛄","🛅","🚸","⛔","🚫","🚳","🚭","🚯","🚱","🚷","📵","🔞","🔃","🔄","🔙",
  "🔚","🔛","🔜","🔝","🛐","🕉","🕎","🔯","⛎","🔀","🔁","🔂","⏩","⏭","⏯","⏪","⏮",
  "🔼","⏫","🔽","⏬","⏸","⏹","⏺","🎦","🔅","🔆","📶","📳","📴","🔱","📛","🔰","⭕",
  "✅","❌","❎","➕","➖","➗","➰","➿","❓","❔","❕","❗","*️⃣","🔟","💯","🔠","🔡",
  "🔢","🔣","🔤","🆎","🆑","🆒","🆓","🆔","🆕","🆖","🆗","🆘","🆙","🆚","🈁","🈶","🈯",
  "🉐","🈹","🈚","🈲","🉑","🈸","🈴","🈳","🈺","🈵","⬛","⬜","🔶","🔷","🔸","🔹","🔺",
  "🔻","💠","🔘","🔲","🔳","⚪","⚫","🔴","🔵","🏁","🚩","🎌","🏴","🏳","🇦🇨","🇦🇩","🇦🇪",
  "🇦🇫","🇦🇬","🇦🇮","🇦🇱","🇦🇲","🇦🇴","🇦🇶","🇦🇷","🇦🇸","🇦🇹","🇦🇺","🇦🇼","🇦🇽","🇦🇿","🇧🇦","🇧🇧","🇧🇩",
  "🇧🇪","🇧🇫","🇧🇬","🇧🇭","🇧🇮","🇧🇯","🇧🇱","🇧🇲","🇧🇳","🇧🇴","🇧🇶","🇧🇷","🇧🇸","🇧🇹","🇧🇻","🇧🇼","🇧🇾",
  "🇧🇿","🇨🇦","🇨🇨","🇨🇩","🇨🇫","🇨🇬","🇨🇭","🇨🇮","🇨🇰","🇨🇱","🇨🇲","🇨🇳","🇨🇴","🇨🇵","🇨🇷","🇨🇺","🇨🇻",
  "🇨🇼","🇨🇽","🇨🇾","🇨🇿","🇩🇪","🇩🇬","🇩🇯","🇩🇰","🇩🇲","🇩🇴","🇩🇿","🇪🇦","🇪🇨","🇪🇪","🇪🇬","🇪🇭","🇪🇷",
  "🇪🇸","🇪🇹","🇪🇺","🇫🇮","🇫🇯","🇫🇰","🇫🇲","🇫🇴","🇫🇷","🇬🇦","🇬🇧","🇬🇩","🇬🇪","🇬🇫","🇬🇬","🇬🇭","🇬🇮",
  "🇬🇱","🇬🇲","🇬🇳","🇬🇵","🇬🇶","🇬🇷","🇬🇸","🇬🇹","🇬🇺","🇬🇼","🇬🇾","🇭🇰","🇭🇲","🇭🇳","🇭🇷","🇭🇹","🇭🇺",
  "🇮🇨","🇮🇩","🇮🇪","🇮🇱","🇮🇲","🇮🇳","🇮🇴","🇮🇶","🇮🇷","🇮🇸","🇮🇹","🇯🇪","🇯🇲","🇯🇴","🇯🇵","🇰🇪","🇰🇬",
  "🇰🇭","🇰🇮","🇰🇲","🇰🇳","🇰🇵","🇰🇷","🇰🇼","🇰🇾","🇰🇿","🇱🇦","🇱🇧","🇱🇨","🇱🇮","🇱🇰","🇱🇷","🇱🇸","🇱🇹",
  "🇱🇺","🇱🇻","🇱🇾","🇲🇦","🇲🇨","🇲🇩","🇲🇪","🇲🇫","🇲🇬","🇲🇭","🇲🇰","🇲🇱","🇲🇲","🇲🇳","🇲🇴","🇲🇵","🇲🇶",
  "🇲🇷","🇲🇸","🇲🇹","🇲🇺","🇲🇻","🇲🇼","🇲🇽","🇲🇾","🇲🇿","🇳🇦","🇳🇨","🇳🇪","🇳🇫","🇳🇬","🇳🇮","🇳🇱","🇳🇴",
  "🇳🇵","🇳🇷","🇳🇺","🇳🇿","🇴🇲","🇵🇦","🇵🇪","🇵🇫","🇵🇬","🇵🇭","🇵🇰","🇵🇱","🇵🇲","🇵🇳","🇵🇷","🇵🇸","🇵🇹",
  "🇵🇼","🇵🇾","🇶🇦","🇷🇪","🇷🇴","🇷🇸","🇷🇺","🇷🇼","🇸🇦","🇸🇧","🇸🇨","🇸🇩","🇸🇪","🇸🇬","🇸🇭","🇸🇮","🇸🇯",
  "🇸🇰","🇸🇱","🇸🇲","🇸🇳","🇸🇴","🇸🇷","🇸🇸","🇸🇹","🇸🇻","🇸🇽","🇸🇾","🇸🇿","🇹🇦","🇹🇨","🇹🇩","🇹🇫","🇹🇬",
  "🇹🇭","🇹🇯","🇹🇰","🇹🇱","🇹🇲","🇹🇳","🇹🇴","🇹🇷","🇹🇹","🇹🇻","🇹🇼","🇹🇿","🇺🇦","🇺🇬","🇺🇲","🇺🇸","🇺🇾",
  "🇺🇿","🇻🇦","🇻🇨","🇻🇪","🇻🇬","🇻🇮","🇻🇳","🇻🇺","🇼🇫","🇼🇸","🇽🇰","🇾🇪","🇾🇹","🇿🇦","🇿🇲","🇿🇼"
];



// WEBPACK FOOTER //
// ./src/emojis.js